import { Component, OnChanges, Inject, ViewChild, Input } from '@angular/core';
import {Location} from '@angular/common';
import { DailyPlanService } from "../services/daily-plan.service";
import { EmergencyService } from "../services/emergency.service";
import { EmergencyActivity } from "../shared/models/emergency/activity.model";
import { EmergencyGroup } from "../shared/models/emergency/group.model";

@Component({
    selector: 'app-emergency',
    templateUrl: './emergency.component.html',
    styleUrls: ['./emergency.component.scss']
})
export class EmergencyComponent implements OnChanges {

    @Input() unit: any;
    @Input() date: any;
    dataLoaded: boolean = false;

    constructor(
        private location: Location,
        private dailyPlan: DailyPlanService,
        private emergencyService: EmergencyService) { }

    ngOnChanges(changes) {
        this.dataLoaded = false;
        this.emergencyService.GetEmergencyActivities({ unitId: this.unit.id, date: this.date }).then(result => {
            this.dataLoaded = true;
            this.emergencyService.emergencySchedules = result.data.emergencyActivities;
            this.emergencyService.emergencyTiers = result.data.tiers;
            this.emergencyService.fte = result.data.fte;
        });
    }

   
}

